import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { environment } from '@env/environment';
import { DomainService } from '@core/services/domain.service';

export const localeGuard: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
  const
    domainService = inject(DomainService),
    checkLocaleRegex = /^[a-zA-Z]{2}-[a-zA-Z]{2}/,
    router = inject(Router);

  if (checkLocaleRegex.test(segments[0].path)) {
    if (environment.domainEnv != 'production') {
      let fullPath: string = '';
      for (const segment of segments) {
        fullPath += '/' + segment.path;
      }
      console.debug(`Routing to : ${fullPath}`);
    }
    return true;
  }
  else {
    const locale: string = domainService.getLocale();

    /* Without a usable locale the rewrite below produces `/null/...`, which fails this very
       check on the next pass and re-navigates - an unbounded router loop that pegs the CPU
       and stops the SSR process answering anything. Bail to the root instead: it is a real
       route on every host, so the navigation always terminates. */
    if (!locale || !checkLocaleRegex.test(locale)) {
      console.debug(`Locale unavailable ('${locale}'). Rerouting to : /`);
      router.navigate(['/']);
      return false;
    }

    let fullPath: string = `/${locale}`;
    for (const segment of segments) {
      fullPath += '/' + segment.path;
    }
    router.navigate([fullPath]);

    console.debug(`Locale not found. Rerouting to : ${fullPath}`);
    return false;
  }
};